var FlagProgressType;
(function (FlagProgressType) {
    FlagProgressType["SELECT_OPTION"] = "select_option";
    FlagProgressType["OPTION_SELECTED"] = "option_selected";
    FlagProgressType["ADD_COMMENT"] = "add_comment";
    FlagProgressType["DONE"] = "DONE";
    FlagProgressType["ERROR"] = "ERROR";
})(FlagProgressType || (FlagProgressType = {}));
export { FlagProgressType };
